document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".routine-pdp-slider");
  sliders.forEach((slider) => {
    const dots = slider.closest(".routine-items").querySelectorAll(".dots-navigation .dot");
    const slides = slider.closest(".routine-items").querySelectorAll(".routine-item");

    if (!slider || dots.length === 0 || slides.length === 0) return;
    const slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(slides[0]).marginRight, 10);

    // Update active dot on scroll
    slider.addEventListener("scroll", () => {
      const scrollLeft = slider.scrollLeft;
      const activeIndex = Math.round(scrollLeft / slideWidth);

      dots.forEach((dot, index) => {
        dot.classList.toggle("active", index === activeIndex);
      });
    });

    // Click event for dots
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const targetScrollPosition = slideWidth * index;
        slider.scrollTo({ left: targetScrollPosition, behavior: "smooth" });
      });
    });

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let isDragging = false;
    let targetScroll = 0;
    let rafId = null;

    slider.querySelectorAll("a").forEach((a) => a.setAttribute("draggable", "false"));

    function smoothScroll() {
      const current = slider.scrollLeft;
      const diff = targetScroll - current;
      if (Math.abs(diff) < 0.5) {
        slider.scrollLeft = targetScroll;
        rafId = null;
        return;
      }
      slider.scrollLeft = current + diff * 0.25;
      rafId = requestAnimationFrame(smoothScroll);
    }

    function stopDrag() {
      if (!isDown) return;
      isDown = false;
      slider.style.cursor = "";
      slider.style.scrollSnapType = "";
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      setTimeout(() => { isDragging = false; }, 0);
    }

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      isDragging = false;
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
      targetScroll = scrollLeft;
      slider.style.cursor = "grabbing";
      slider.style.scrollSnapType = "none";
    });

    slider.addEventListener("mouseleave", stopDrag);
    document.addEventListener("mouseup", stopDrag);

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      isDragging = true;
      const walk = e.pageX - startX;
      targetScroll = scrollLeft - walk;
      if (!rafId) rafId = requestAnimationFrame(smoothScroll);
    });

    slider.addEventListener("click", (e) => {
      if (isDragging) e.preventDefault();
    });
  });
});
